<template>
  <div>
    <div class="mt-15 container card_container">
      <h3 class="mb-5 titolo"><i class="fas fa-at"></i> CONTATTI</h3>
        <section class="contatti-section">
            <h2>{{TitoloAssistenzaCup}}</h2>
            <p>{{MessaggioAssistenzaCup}}  <strong>{{ MumeroAssistenzaCup }}</strong></p>
        </section>
        <section class="segnalazioni-section">
            <h2>{{TitoloAssistenzaTecnica}}</h2>
            <p>{{MessaggioAssistenzaTecnica}} <strong>{{ NumeroAssistenzaTecnica }}</strong></p>
            <button class="btn btn-primary" @click="apriModuloSegnalazione">Modulo di Segnalazione</button>
            <!-- Modale per il modulo di segnalazione -->
            <b-modal hide-header-close hide-footer ref="modalSegnalazione" title="Modulo di Segnalazione">
                <section>
                    <div>

                        <b-row v-if="assistito">
                          <b-row>
                            <b-col sm class="mb-12">
                              <span class="text-primary">GRUPPO DI ASSISTENZA</span><br/>
                              <b-select v-model="assistenzaSelected" :options="options" />
                            </b-col>
                          </b-row>
                            <b-col sm class="mb-7">
                                <span class="text-primary">Assistito</span><br/>
                                <span>{{ assistito.nome }} {{ assistito.cognome }}</span>
                            </b-col>
                            <b-col sm class="mb-7">
                                <span class="text-primary">Codice Fiscale</span><br/>
                                <span>{{ assistito.codiceFiscale }}</span>
                            </b-col>
                        </b-row>
                        <div v-else>
                            <b-row>
                                <b-col sm class="mb-7 mt-5">
                                    <div class="h-35px">
                                        <strong class="text-primary">Nome</strong>
                                    </div>
                                    <b-form-input
                                            type="text"
                                            class="form-control form-control-solid"
                                            name="nome"
                                            placeholder=""
                                            value=""
                                            maxlength="20"
                                            style="text-transform: uppercase"
                                            v-model="nome"
                                            required
                                    />
                                </b-col>
                                <b-col sm class="mb-7 mt-5">
                                    <div class="h-35px">
                                        <strong class="text-primary">Cognome</strong>
                                    </div>
                                    <b-form-input
                                            type="text"
                                            class="form-control form-control-solid"
                                            name="cognome"
                                            placeholder=""
                                            value=""
                                            style="text-transform: uppercase"
                                            maxlength="20"
                                            v-model="cognome"
                                            required
                                    />
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col sm class="mb-7">
                                    <div class="h-35px">
                                        <strong class="text-primary">Numero di telefono</strong>
                                    </div>
                                    <b-form-input
                                            type="text"
                                            class="form-control form-control-solid"
                                            name="telefono"
                                            placeholder=""
                                            value=""
                                            style="text-transform: uppercase"
                                            maxlength="12"
                                            v-model="telefono"
                                            required
                                    />
                                </b-col>
                                <b-col sm class="mb-7">
                                    <div class="h-35px">
                                        <strong class="text-primary">Email</strong>
                                    </div>
                                    <b-form-input
                                            type="text"
                                            class="form-control form-control-solid"
                                            name="email"
                                            placeholder=""
                                            value=""
                                            style="text-transform: uppercase"
                                            maxlength="20"
                                            v-model="email"
                                            required
                                    />
                                </b-col>
                            </b-row>
                        </div>
                        <b-row>
                            <b-col sm class="mb-7">
                                <span class="text-primary">Messaggio</span><br/>
                                <b-form-textarea v-model="messaggio" debounce="500" class="mt-2"></b-form-textarea>
                            </b-col>
                        </b-row>
                        <b-row>
                            <div class="footer d-flex justify-content-end">
                                <b-button class="ml-2 btn-outline" @click="onInvia" :disabled="abilitaProcedi">
                                    <i class="fas fa-paper-plane"></i> Invia
                                </b-button>
                            </div>
                        </b-row>
                    </div>
                </section>
            </b-modal>
        </section>


    </div>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" color="#274561" loader="dots"
             :height="120" :width="120"></loading>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import AuthService from "@/services/authService";
import UtilService from "@/services/utilService";
import getVocabolario from "@/utilities/utilityCercaVocabolario";

export default {
  components: {
    Loading,
  },
  data() {
    return {
      options:[
          { value: null, text: 'Seleziona un gruppo di assistenza' },
        { value: 0, text:  "Assistenza CUP" },
        { value: 1, text:  "Assistenza Tecnica" }
      ],
      assistenzaSelected:null,
        pathResorceInfoUtente: "/api/v2.0/appecupt/auth/prelevaAnagraficaUtente",
        pathResorceInviaMessaggio: "/urlserviziapp/emailAssistenza",
        messaggio: null,
        assistito: null,
        isLoading: false,
        nome: null,
        cognome: null,
        telefono: null,
        email: null,
        TitoloAssistenzaCup:"",
        MessaggioAssistenzaCup:"",
        MumeroAssistenzaCup:"",
        TitoloAssistenzaTecnica:"Segnalazioni di Malfunzionamenti Tecnici",
        MessaggioAssistenzaTecnica:"Per segnalazioni di malfunzionamenti tecnici utilizzare il seguente modulo di invio segnalazione:",
        NumeroAssistenzaTecnica:""
    };
  },
  computed: {
    abilitaProcedi() {
      if(!this.assistito)
        return !(this.nome && this.cognome && this.telefono && this.email && this.messaggio && this.assistenzaSelected!=undefined);
      else
        return !(this.messaggio && this.assistenzaSelected!=undefined);
    }
  },
  mounted: function () {
    let me = this;
    me.tokenLogin = sessionStorage.getItem("loginData");
    if (me.tokenLogin) {
      me.loadInfoUtente();
    }else {
      me.assistenzaSelected= me.options[1]
    }
    this.controlloVocabolario()
  },
  methods: {
      apriModuloSegnalazione() {
          // Apri la modale del modulo di segnalazione
          this.$refs.modalSegnalazione.show()
      },

      controlloVocabolario(){
          let msg = getVocabolario("titoloAssistenzaCup")
          console.log(msg)
          if(msg)
              this.TitoloAssistenzaCup = msg
          msg = getVocabolario("messaggioAssistenzaCup")
          if(msg)
              this.MessaggioAssistenzaCup = msg
          msg = getVocabolario("numeroAssistenzaCup")
          if(msg)
              this.MumeroAssistenzaCup = msg
          msg = getVocabolario("titoloAssistenzaTecnica")
          if(msg)
              this.TitoloAssistenzaTecnica = msg
          msg = getVocabolario("messaggioAssistenzaTecnica")
          if(msg)
              this.MessaggioAssistenzaTecnica = msg
          msg = getVocabolario("numeroAssistenzaTecnica")
          if(msg)
              this.NumeroAssistenzaTecnica = msg
      },
    async loadInfoUtente() {
      let me = this;
      try {
        const responseInfoUtente = await AuthService.anagraficaUtente(me.tokenLogin);
        me.assistito = responseInfoUtente.data.data;
      } catch (error) {
        me.$bvModal
            .msgBoxOk(error, {
              title: "Errore",
              size: "md",
              okVariant: "outline-danger",
              headerClass: "vv-msg-header-danger",
              footerClass: "p-2 border-top-0",
              centered: true,
            })
            .then(() => {
            })
            .catch(() => {
            });
      }
    },
    async onInvia() {
      let me = this;
      me.isLoading = true;
      let parametriSupporto;
      if(this.assistito){
        parametriSupporto = {
          messaggio: this.messaggio,
          nome: this.assistito.nome,
          cognome: this.assistito.cognome,
          telefono: this.assistito.numeroCellulare,
          email: this.assistito.email,
          codiceServizio: 0,
          codiceFiscale: this.assistito.codiceFiscale,
          AssistenzaSelezionata: this.assistenzaSelected
        }
      } else {
        parametriSupporto = {
          messaggio: this.messaggio,
          nome: this.nome,
          cognome: this.cognome,
          telefono: this.telefono,
          email: this.email,
          AssistenzaSelezionata: this.assistenzaSelected

        };
      }
      try {
        const responeInvioMailSupporto = await UtilService.supportoMail(parametriSupporto);
        if (responeInvioMailSupporto.data.stato === 200) {
          me.isLoading = false;
            this.$refs.modalSegnalazione.hide()
          me.$bvModal
              .msgBoxOk(responeInvioMailSupporto.data.data, {
                title: "Invio Richiesta Supporto",
                size: "md",
                okVariant: "outline-success",
                headerClass: "vv-msg-header-success",
                footerClass: "p-2 border-top-0",
                centered: true,
              })
              .then(() => {
              })
              .catch(() => {
              });
        } else {
          me.isLoading = false;
          me.$bvModal
              .msgBoxOk(responeInvioMailSupporto.data.errore, {
                title: "Errore",
                size: "md",
                okVariant: "outline-success",
                headerClass: "vv-msg-header-success",
                footerClass: "p-2 border-top-0",
                centered: true,
              })
              .then(() => {
              })
              .catch(() => {
              });
        }
      } catch (error) {
        me.isLoading = false;
        me.$bvModal
            .msgBoxOk(error, {
              title: "Errore",
              size: "md",
              okVariant: "outline-danger",
              headerClass: "vv-msg-header-danger",
              footerClass: "p-2 border-top-0",
              centered: true,
            })
            .then(() => {
            })
            .catch(() => {
            });
      }
    },
  },
};
</script>
